function fnAnimations() {
    const logoWall = document.getElementsByClassName('logowall')[0];
    if(!logoWall) return;
    
    const logos = logoWall.querySelectorAll('.stagger');

    // Logo wall stagger animation using GSAP ScrollTrigger
    gsap.fromTo(logos, 
        { opacity: 0, y: 80 }, 
        { 
            opacity: 1, 
            y: 0, 
            duration: 1,
            ease: "expo.out",
            stagger: 0.25,
            scrollTrigger: {
                trigger: logoWall,
                start: "top center",
                toggleActions: "play none none none"
            }
        }
    );
}